import { DATABASEOVERVIEW } from "../../constants/action-types";
const initialState = {
    averageOpenRateDetailData: [],
    peopleRecentEmailData: [],
    revenueByTopCustomerData: [],
    recentCustomersData: [],
    emailEngagementData: [],
    peopleWithEmailDetailData: [],
    averageOrderValueDetailData: [],
    peopleSummaryDetailData: [],
    cumulativeData: [],
    databaseData: [],
    PeopleCountSummary: [],
    AverageOrderValueSummary: [],
    peopleWithEmailSummary: [],
    EmailEngagementSummary: [],
    RecentCustomerSummary: [],
    attrRevenueDetail: [],
    AttrRevenueSummary: [],
    RevenueDrivenByTopCustomersSummary: [],
    PeopleRecentlyEmailedSummary: [],
    AverageOpenRateSummary: [],
    detailDivClass: [],
    detailChart: [],
    detailChartBorderColor: [],
    highestAverageOrderValue: null

}

const DatabaseOverviewReducer = (state = initialState, action) => {
    switch (action.type) {
        case DATABASEOVERVIEW.DETAIL_CHART: {
            return Object.assign({}, state, {
                detailDivClass: action.payload.detailDivClass,
                detailChart: action.payload.detailChart,
                detailChartBorderColor: action.payload.detailChartBorderColory
            });

        }
        case DATABASEOVERVIEW.AVERAGE_OPEN_RATE_SUMMARY_UPDATE: {
            return Object.assign({}, state, {
                AverageOpenRateSummary: action.payload
            });

        }
        case DATABASEOVERVIEW.PEOPLE_RECENTLY_EMAILED_SUMMARY_UPDATE: {
            return Object.assign({}, state, {
                PeopleRecentlyEmailedSummary: action.payload
            });

        }
        case DATABASEOVERVIEW.REVENUE_DRIVEN_BY_TOP_CUSTOMERS_SUMMARY_UPDATE: {
            return Object.assign({}, state, {
                RevenueDrivenByTopCustomersSummary: action.payload
            });

        }
        case DATABASEOVERVIEW.RECENT_CUSTOMER_SUMMARY_UPDATE: {
            return Object.assign({}, state, {
                RecentCustomerSummary: action.payload
            });

        }
        case DATABASEOVERVIEW.EMAIL_ENGAGEMENT_SUMMARY_UPDATE: {
            return Object.assign({}, state, {
                EmailEngagementSummary: action.payload
            });

        }
        case DATABASEOVERVIEW.PEOPLE_WITH_EMAIL_SUMMARY_UPDATE: {
            return Object.assign({}, state, {
                peopleWithEmailSummary: action.payload
            });

        }
        case DATABASEOVERVIEW.AVERAGE_ORDER_VALUE_SUMMARY_UPDATE: {
            return Object.assign({}, state, {
                AverageOrderValueSummary: action.payload
            });

        }
        case DATABASEOVERVIEW.ATTRIBUTED_REVENUE_DETAIL_UPDATE: {
            return Object.assign({}, state, {
                attrRevenueDetail: action.payload
            });

        }
        case DATABASEOVERVIEW.ATTRIBUTED_REVENUE_SUMMARY_UPDATE: {
            return Object.assign({}, state, {
                AttrRevenueSummary: action.payload
            });

        }
        case DATABASEOVERVIEW.PEOPLE_COUNT_SUMMARY_UPDATE: {
            return Object.assign({}, state, {
                PeopleCountSummary: action.payload
            });

        }


        case DATABASEOVERVIEW.UPDATE_DATABASE_GROWTH_DATABASE: {
            return Object.assign({}, state, {
                databaseData: action.payload
            });

        }
        case DATABASEOVERVIEW.UPDATE_DATABASE_GROWTH_CUMULATIVE: {
            return Object.assign({}, state, {
                cumulativeData: action.payload
            });

        }
        case DATABASEOVERVIEW.SUMMARY_PEOPLE_DETAIL_UPDATE: {
            return Object.assign({}, state, {
                peopleSummaryDetailData: action.payload
            });

        }
        case DATABASEOVERVIEW.SUMMARY_AVERAGE_ORDER_VALUE_DETAIL_UPDATE: {
            return Object.assign({}, state, {
                averageOrderValueDetailData: action.payload
            });

        }
        case DATABASEOVERVIEW.SUMMARY_HIGHEST_AVERAGE_ORDER_VALUE_DETAIL_UPDATE: {
            return Object.assign({}, state, {
                highestAverageOrderValue: action.payload
            });

        }
        case DATABASEOVERVIEW.SUMMARY_AVERAGE_OPEN_RATE_DETAIL_UPDATE: {
            return Object.assign({}, state, {
                averageOpenRateDetailData: action.payload
            });

        }
        case DATABASEOVERVIEW.SUMMARY_PEOPLE_RECENT_EMAIL_DETAIL_UPDATE: {
            return Object.assign({}, state, {
                peopleRecentEmailData: action.payload
            });

        }
        case DATABASEOVERVIEW.SUMMARY_REVENUE_TOP_CUSTOMER_DETAIL_UPDATE: {
            return Object.assign({}, state, {
                revenueByTopCustomerData: action.payload
            });

        }
        case DATABASEOVERVIEW.SUMMARY_RECENT_CUSTOMERS_DETAIL_UPDATE: {
            return Object.assign({}, state, {
                recentCustomersData: action.payload
            });

        }
        case DATABASEOVERVIEW.SUMMARY_EMAIL_ENGAGEMENT_DETAIL_UPDATE: {
            return Object.assign({}, state, {
                emailEngagementData: action.payload
            });

        }
        case DATABASEOVERVIEW.SUMMARY_PEOPLE_WITH_EMAIL_DETAIL_UPDATE: {
            return Object.assign({}, state, {
                peopleWithEmailDetailData: action.payload
            });

        }
        default:
            return state
    }

}

export default DatabaseOverviewReducer
